import React, { useState, useRef } from "react";
import { Paperclip, Send, X, Camera, Mic, Smile, Square, Pause, Play, Trash2, Clock, LayoutTemplate } from "lucide-react";
import EmojiPicker from "emoji-picker-react";
import { useAPI } from "../Context/MyContext";
import { useEffect } from "react";

const TemplateModal = ({
  onClose,
  templates = [],
  onSelectTemplate,
  selectedTemplate,
  variables,
  setVariables,
  onSend,
}) => {
  const [search, setSearch] = useState("");

  // console.log("templete are selected now", selectedTemplate)

  const getComponent = (template, type) =>
    template?.components?.find((c) => c.type === type);

  // Extract variables from ALL parts (header + body)
  // Extract variables from ALL parts (header + body)
  const extractVariables = (template) => {
    if (!template) return [];

    const texts = ["HEADER", "BODY"]
      .map((type) => getComponent(template, type)?.text || "")
      .join(" ");

    const matches = texts.match(/{{\s*\d+\s*}}/g) || [];

    return matches.map((m) => {
      const num = m.match(/\d+/)[0]; // get the number inside {{1}}, {{2}}, etc.
      return {
        key: `var_${num}`,
        placeholder: m,
      };
    });
  };

  // const replaceVars = (text) => {
  //   return text.replace(/{{\s*(\d+)\s*}}/g, (_, num) => {
  //     const key = `var_${num}`;
  //     return variables[key] || `{{${num}}}`;
  //   });
  // };
  const replaceVars = (text = "") => {
    return text.replace(/{{\s*(\d+)\s*}}/g, (_, num) => {
      const key = `var_${num}`;
      return variables[key] || `{{${num}}}`;
    });
  };

  const filtered = templates.filter((t) => {
    const body = getComponent(t, "BODY")?.text || "";
    return (
      t.name?.toLowerCase().includes(search.toLowerCase()) ||
      body.toLowerCase().includes(search.toLowerCase())
    );
  });

  const currentVariables = extractVariables(selectedTemplate);

  const header = getComponent(selectedTemplate, "HEADER");
  const body = getComponent(selectedTemplate, "BODY");
  const footer = getComponent(selectedTemplate, "FOOTER");



  const areAllVariablesFilled = currentVariables.every((v) => {
    const value = variables[v.key];
    return value && value.trim() !== "";
  });

  return (
    <div className="absolute bottom-full left-0 right-0 mb-2 mx-3 bg-white rounded-2xl shadow-2xl border z-50 overflow-hidden">

      {/* Header */}
      <div className="flex justify-between px-4 py-3 border-b">
        <span className="text-xs font-semibold uppercase">Templates</span>
        <button onClick={onClose}><X size={16} /></button>
      </div>

      {/* Search */}
      <div className="p-3 border-b">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search templates..."
          className="w-full px-3 py-2 bg-gray-100 rounded-lg text-sm"
        />
      </div>

      {/* List */}
      <div className="max-h-[200px] overflow-y-auto">
        {filtered.map((t) => (
          <button
            key={t.name}
            onClick={() => onSelectTemplate(t)}
            className={`w-full text-left px-4 py-3 border-b ${selectedTemplate?.name === t.name ? "bg-green-50" : ""
              }`}
          >
            <div className="text-sm font-semibold">{t.name}</div>
          </button>
        ))}
      </div>

      {/* Preview + Variables */}
      {selectedTemplate && (
        <div className="p-3 bg-gray-50 space-y-3">

          {/* WhatsApp Style Preview */}
          <div className="bg-white rounded-xl p-3 border text-sm space-y-2">

            {/* HEADER */}
            {header && header.format === "TEXT" && (
              <div className="font-semibold whitespace-pre-line">
                {replaceVars(header.text)}
              </div>
            )}

            {header && header.format === "IMAGE" && (
              <img
                src={header.example?.header_handle?.[0]}
                alt="template"
                // className="w-full h-40 object-cover rounded"
                className="w-full max-h-60 object-contain bg-gray-100 rounded"
              />
            )}

            {/* BODY */}
            {body && (
              <div className="whitespace-pre-line">{replaceVars(body.text)}</div>
            )}

            {/* FOOTER */}
            {footer && (
              <div className="text-xs text-gray-500">
                {footer.text}
              </div>
            )}
          </div>

          {/* Variables */}
          {currentVariables.map((v) => (
            <input
              key={v.key}
              placeholder={`Enter ${v.placeholder}`}
              value={variables[v.key] || ""}
              onChange={(e) =>
                setVariables((prev) => ({
                  ...prev,
                  [v.key]: e.target.value,
                }))
              }
              className="w-full px-3 py-2 border rounded-lg text-sm"
            />
          ))}

          {/* Send */}
          {/* <button
            onClick={onSend}
            className="w-full bg-[#00a884] text-white py-2 rounded-lg"
          >
            Send Template
          </button> */}

          <button
  onClick={onSend}
  disabled={!areAllVariablesFilled}
  className={`w-full py-2 rounded-lg text-white ${
    areAllVariablesFilled
      ? "bg-[#00a884]"
      : "bg-gray-300 cursor-not-allowed"
  }`}
>
  Send Template
</button>
        </div>
      )}
    </div>
  );
};




const MessageInput = ({ onSendMessage, recipientId, phoneId, recipientNumber, isAllowedToSendMessage, cswStatus, replyMessage, setReplyMessage }) => {
  const [message, setMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [caption, setCaption] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showEmoji, setShowEmoji] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isSendingAudio, setIsSendingAudio] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [showTemplates, setShowTemplates] = useState(false);

  // Access control based on CSW status
  const isTextAllowed = cswStatus?.allowed?.text ?? false;
  const isMediaAllowed = cswStatus?.allowed?.media ?? false;

  // Recording states
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [draftAudio, setDraftAudio] = useState(null);
  const [audioBlob, setAudioBlob] = useState(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [waveformData, setWaveformData] = useState([]);
  const [isPlayingPreview, setIsPlayingPreview] = useState(false);
  const [draftAudioDuration, setDraftAudioDuration] = useState(0);

  const chunksRef = useRef([]);
  const cameraRef = useRef(null);
  const fileRef = useRef(null);
  const recordingTimerRef = useRef(null);
  const isDeletingRef = useRef(false);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const animationFrameRef = useRef(null);
  const previewAudioRef = useRef(null);
  const shouldSendAfterStopRef = useRef(false);

  // api
  const { SendVoiceMessage, getUserWabaIds, getTemplateByWabaId } = useAPI();


  const [wabaIds, setWabaIds] = useState([]);
  const [selectedWabaId, setSelectedWabaId] = useState("");
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templateVariables, setTemplateVariables] = useState({});



  useEffect(() => {
    (async () => {
      try {
        const res = await getUserWabaIds();
        const data = Array.isArray(res) ? res[0]?.data : res?.data || [];

        const mapped = data.map((item) => ({
          id: item.waba_id,
          name: item.verified_name,
          phoneId: item.phone_number_id,
        }));

        setWabaIds(mapped); // ✅ always store full list

        // ✅ find matching WABA by phoneId
        const matched = mapped.find((waba) => waba.phoneId === phoneId);

        if (matched) {
          // console.log("Matched WABA:", matched);
          setSelectedWabaId(matched.id); // ✅ set correct one
        } else if (mapped.length) {
          // fallback
          setSelectedWabaId(mapped[0].id);
        }

      } catch (err) {
        console.error("WABA fetch failed");
      }
    })();
  }, [phoneId]); // ✅ IMPORTANT dependency


  useEffect(() => {
    if (!selectedWabaId) return;

    (async () => {
      try {
        const res = await getTemplateByWabaId(selectedWabaId);
        setTemplates(res?.data || []);
      } catch (err) {
        console.error("Template fetch failed");
      }
    })();
  }, [selectedWabaId]);


  const extractVariables = (template) => {
    if (!template) return [];

    const body = template.components?.find(c => c.type === "BODY")?.text || "";
    const matches = body.match(/{{\s*\d+\s*}}/g) || [];

    return matches.map((m, i) => ({
      key: `var_${i}`,
      placeholder: m,
    }));
  };



  const handleTemplateSelect = (template) => {
    console.log("Selected templates are:", template);

    // setSelectedTemplate(template.raw); // ✅ important
    setSelectedTemplate(template); // ✅ important
    setTemplateVariables({});
  };


  // const handleSendTemplate = () => {

  //   if (!selectedTemplate) return;

  //   const components = [];

  //   selectedTemplate.components.forEach((comp) => {

  //     // HEADER
  //     if (comp.type === "HEADER") {

  //       if (comp.format === "TEXT") {
  //         const matches = comp.text.match(/{{\d+}}/g) || [];

  //         components.push({
  //           type: "header",
  //           parameters: matches.map((m) => {
  //             const num = m.match(/\d+/)[0];
  //             return {
  //               type: "text",
  //               text: templateVariables[`var_${num}`] || "",
  //             };
  //           }),
  //         });
  //       }

  //       if (["IMAGE", "VIDEO", "DOCUMENT"].includes(comp.format)) {
  //         components.push({
  //           type: "header",
  //           parameters: [
  //             {
  //               type: comp.format.toLowerCase(),
  //               link: comp.example?.header_handle?.[0],
  //             },
  //           ],
  //         });
  //       }
  //     }

  //     // BODY
  //     if (comp.type === "BODY") {
  //       const matches = comp.text.match(/{{\d+}}/g) || [];

  //       components.push({
  //         type: "body",
  //         parameters: matches.map((m) => {
  //           const num = m.match(/\d+/)[0];
  //           return {
  //             type: "text",
  //             text: templateVariables[`var_${num}`] || "",
  //           };
  //         }),
  //       });
  //     }
  //   });

  //   console.log("Templerte components are :", components)
  //   onSendMessage(null, null, "", "template", {
  //     templateName: selectedTemplate.name,
  //     language: selectedTemplate.language || "en_US",
  //     components,
  //     // phoneId,
  //   });


  //   setShowTemplates(false);
  //   setSelectedTemplate(null);
  //   setTemplateVariables({});
  // };


  const handleSendTemplate = () => {
    if (!selectedTemplate) return;

    const components = [];

    selectedTemplate.components.forEach((comp) => {

      // HEADER
      if (comp.type === "HEADER" && comp.format === "TEXT") {
        const matches = comp.text.match(/{{\d+}}/g);

        if (matches && matches.length > 0) {
          components.push({
            type: "header",
            parameters: matches.map((m) => {
              const num = m.match(/\d+/)[0];
              return {
                type: "text",
                text: templateVariables[`var_${num}`] || "",
              };
            }),
          });
        }
      }

      // BODY
      if (comp.type === "BODY") {
        const matches = comp.text.match(/{{\d+}}/g);

        if (matches && matches.length > 0) {
          components.push({
            type: "body",
            parameters: matches.map((m) => {
              const num = m.match(/\d+/)[0];
              return {
                type: "text",
                text: templateVariables[`var_${num}`] || "",
              };
            }),
          });
        }
      }

    });

    console.log("Final components:", components);

    onSendMessage(null, null, "", "template", {
      templateName: selectedTemplate.name,
      language: selectedTemplate.language || "en_US",
      components, // 👈 will be [] if no variables
    });

    setShowTemplates(false);
    setSelectedTemplate(null);
    setTemplateVariables({});
  };


  const getFileType = (file) => {
    const mimeType = file.type;
    if (mimeType.startsWith("image/")) return "image";
    if (mimeType.startsWith("video/")) return "video";
    if (mimeType.startsWith("audio/")) return "audio";
    return "document";
  };

  const closeModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setShowModal(false);
      setIsClosing(false);
    }, 200);
  };

  const handleFilesChange = (e) => {
    const selected = Array.from(e.target.files);
    if (!selected.length) return;

    const isCameraUpload = e.target === cameraRef.current;
    let filteredFiles = selected;

    if (isCameraUpload) {
      filteredFiles = selected.filter(file => file.type.startsWith("image/"));
    }

    if (filteredFiles.length === 0) {
      alert("Only image files are allowed from camera.");
      return;
    }

    setFiles(filteredFiles);
    setPreviews(filteredFiles.map((f) => URL.createObjectURL(f)));
    setCaption("");
    setCurrentIndex(0);
    setShowModal(true);
    e.target.value = "";
  };

  const sendImages = () => {
    if (!phoneId || !recipientNumber) {
      alert("Missing contact information. Please select a contact first.");
      return;
    }
    files.forEach((file) => {
      const fileType = getFileType(file);
      onSendMessage("", file, caption, fileType);
    });
    reset();
  };

  const reset = () => {
    setFiles([]);
    setPreviews([]);
    setCaption("");
    setShowModal(false);
  };



  const visualizeAudio = () => {
    if (!analyserRef.current) return;
    const analyser = analyserRef.current;
    const bufferLength = analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    const updateWaveform = () => {
      if (!analyserRef.current) return;
      analyser.getByteTimeDomainData(dataArray);
      const bars = 60;
      const step = Math.floor(bufferLength / bars);
      const newWaveform = [];
      for (let i = 0; i < bars; i++) {
        const index = i * step;
        const value = dataArray[index];
        const normalized = Math.abs((value - 128) / 128);
        const height = 6 + normalized * 18;
        newWaveform.push(height);
      }
      setWaveformData(newWaveform);
      animationFrameRef.current = requestAnimationFrame(updateWaveform);
    };
    updateWaveform();
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
        video: false,
      });

      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const analyser = audioContext.createAnalyser();
      const source = audioContext.createMediaStreamSource(stream);
      analyser.fftSize = 2048;
      source.connect(analyser);
      audioContextRef.current = audioContext;
      analyserRef.current = analyser;
      visualizeAudio();

      let mimeType = "";
      const preferredTypes = ["audio/ogg;codecs=opus", "audio/webm;codecs=opus", "audio/mp4", "audio/mpeg", "audio/ogg"];
      for (const type of preferredTypes) {
        if (MediaRecorder.isTypeSupported(type)) { mimeType = type; break; }
      }

      const recorder = new MediaRecorder(stream, { mimeType: mimeType || undefined });
      recorder.ondataavailable = (e) => { if (e.data.size > 0) chunksRef.current.push(e.data); };
      recorder.onstop = () => {
        if (animationFrameRef.current) { cancelAnimationFrame(animationFrameRef.current); animationFrameRef.current = null; }
        if (!isDeletingRef.current && audioContextRef.current) {
          if (audioContextRef.current.state !== "closed") audioContextRef.current.close().catch(() => { });
          audioContextRef.current = null;
          analyserRef.current = null;
        }
        if (isDeletingRef.current) { chunksRef.current = []; isDeletingRef.current = false; setWaveformData([]); return; }
        const audioBlob = new Blob(chunksRef.current, { type: mimeType });
        chunksRef.current = [];
        setAudioBlob(audioBlob);
        const tempAudio = new Audio(URL.createObjectURL(audioBlob));
        tempAudio.onloadedmetadata = () => setDraftAudioDuration(Math.round(tempAudio.duration));
        if (shouldSendAfterStopRef.current) { shouldSendAfterStopRef.current = false; sendAudioDirectWithBlob(audioBlob); }
        else setDraftAudio(URL.createObjectURL(audioBlob));
      };

      recorder.start(500);
      setMediaRecorder(recorder);
      setIsRecording(true);
      setIsPaused(false);
      setWaveformData([]);
      setRecordingTime(0);
      recordingTimerRef.current = setInterval(() => setRecordingTime((prev) => prev + 1), 1000);
    } catch (err) {
      alert("Microphone access is required for voice messages.");
    }
  };

  const pauseRecording = () => {
    if (mediaRecorder && mediaRecorder.state === "recording") {
      mediaRecorder.pause();
      setIsPaused(true);
      if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
      if (recordingTimerRef.current) { clearInterval(recordingTimerRef.current); recordingTimerRef.current = null; }
      if (chunksRef.current.length > 0) {
        const tempBlob = new Blob(chunksRef.current, { type: mediaRecorder.mimeType });
        const tempUrl = URL.createObjectURL(tempBlob);
        if (previewAudioRef.current) { previewAudioRef.current.pause(); URL.revokeObjectURL(previewAudioRef.current.src); }
        previewAudioRef.current = new Audio(tempUrl);
        previewAudioRef.current.onended = () => setIsPlayingPreview(false);
      }
    }
  };

  const resumeRecording = () => {
    if (mediaRecorder && mediaRecorder.state === "paused") {
      mediaRecorder.resume();
      setIsPaused(false);
      if (previewAudioRef.current) { previewAudioRef.current.pause(); setIsPlayingPreview(false); }
      visualizeAudio();
      recordingTimerRef.current = setInterval(() => setRecordingTime((prev) => prev + 1), 1000);
    }
  };

  const togglePreviewPlayback = () => {
    if (!previewAudioRef.current || !isPaused) return;
    if (isPlayingPreview) { previewAudioRef.current.pause(); setIsPlayingPreview(false); }
    else { previewAudioRef.current.play(); setIsPlayingPreview(true); }
  };

  const stopRecording = () => {
    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      mediaRecorder.stop();
      if (mediaRecorder.stream) mediaRecorder.stream.getTracks().forEach((track) => track.stop());
      setIsRecording(false);
      setIsPaused(false);
      setMediaRecorder(null);
    }
    if (previewAudioRef.current) { previewAudioRef.current.pause(); URL.revokeObjectURL(previewAudioRef.current.src); previewAudioRef.current = null; }
    setIsPlayingPreview(false);
  };

  const deleteRecording = () => {
    isDeletingRef.current = true;
    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      mediaRecorder.stop();
      if (mediaRecorder.stream) mediaRecorder.stream.getTracks().forEach((track) => track.stop());
    }
    if (animationFrameRef.current) { cancelAnimationFrame(animationFrameRef.current); animationFrameRef.current = null; }
    if (audioContextRef.current && audioContextRef.current.state !== "closed") audioContextRef.current.close().catch(() => { });
    audioContextRef.current = null;
    analyserRef.current = null;
    if (previewAudioRef.current) { previewAudioRef.current.pause(); URL.revokeObjectURL(previewAudioRef.current.src); previewAudioRef.current = null; }
    setIsRecording(false); setIsPaused(false); setMediaRecorder(null); setDraftAudio(null);
    setAudioBlob(null); setRecordingTime(0); setWaveformData([]); setIsPlayingPreview(false);
    if (recordingTimerRef.current) { clearInterval(recordingTimerRef.current); recordingTimerRef.current = null; }
    chunksRef.current = [];
  };

  const sendAudioDirect = async () => {
    if (!audioBlob) return;
    if (!phoneId || !recipientNumber) { alert("Please select a contact first."); return; }
    setIsSendingAudio(true);
    try {
      const extension = audioBlob.type.includes("ogg") ? "ogg" : audioBlob.type.includes("webm") ? "webm" : "mp4";
      const fileName = `voice_message.${extension}`;
      const audioFile = new File([audioBlob], fileName, { type: audioBlob.type });
      const result = await SendVoiceMessage({ phone_number_id: phoneId.toString(), recipient_id: recipientNumber.toString(), file: audioFile });
      setDraftAudio(null); setAudioBlob(null); setRecordingTime(0);
    } catch (err) {
      console.error("Audio send failed:", err);
      setDraftAudio(null); setAudioBlob(null); setRecordingTime(0);
    } finally {
      setIsSendingAudio(false);
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const sendAudioDirectWithBlob = async (blob) => {
    if (!blob) return;
    if (!phoneId || !recipientNumber) { alert("Please select a contact first."); return; }
    setIsSendingAudio(true);
    try {
      const extension = blob.type.includes("ogg") ? "ogg" : blob.type.includes("webm") ? "webm" : "mp4";
      const fileName = `voice_message.${extension}`;
      const audioFile = new File([blob], fileName, { type: blob.type });
      await SendVoiceMessage({ phone_number_id: phoneId.toString(), recipient_id: recipientNumber.toString(), file: audioFile });
      setDraftAudio(null); setAudioBlob(null); setRecordingTime(0);
    } catch (err) {
      console.error("Audio send failed:", err);
    } finally {
      setIsSendingAudio(false);
    }
  };

  return (
    <>
      {replyMessage && (
        <div className="flex items-start justify-between bg-[#f0f2f5] border-l-4 border-green-500 px-3 py-2">
          <div className="flex flex-col text-sm">
            <span className="text-green-600 font-semibold">
              {replyMessage.sender === "user" ? "You" : "User"}
            </span>
            <span className="text-gray-700 truncate max-w-[300px]">
              {replyMessage.type === "text" ? replyMessage.content : `📎 ${replyMessage.type}`}
            </span>
          </div>
          <button onClick={() => setReplyMessage(null)} className="text-gray-500 hover:text-black">✕</button>
        </div>
      )}

      {/* File Preview Modal */}
      {showModal && (
        <div
          className={`absolute top-[60px] left-0 border border-top-1 right-0 bottom-0 bg-[#f0f2f5] flex flex-col z-[100]
            ${isClosing ? 'animate-[slideDownDrawer_0.2s_ease-out]' : 'animate-[slideUpDrawer_0.2s_ease-out]'}`}
          style={{ animation: isClosing ? 'slideDownDrawer 0.2s ease-out' : 'slideUpDrawer 0.2s ease-out' }}
        >
          <div className="flex items-center px-4 py-3 bg-white">
            <button onClick={closeModal} className="text-[#54656f]"><X size={20} /></button>
            <span className="text-[#111b21] text-sm absolute left-1/2 -translate-x-1/2 truncate max-w-[60%]">
              {files[currentIndex]?.name}
            </span>
          </div>
          <div className="flex-1 flex items-center justify-center bg-[#ffffff]">
            {getFileType(files[currentIndex]) === "image" && (
              <img src={previews[currentIndex]} alt="preview" className="max-h-[70vh] max-w-[90%] object-contain" />
            )}
            {getFileType(files[currentIndex]) === "video" && (
              <video src={previews[currentIndex]} controls className="max-h-[70vh] max-w-[90%]" />
            )}
            {getFileType(files[currentIndex]) === "document" && (
              <div className="bg-[#d1d7db] rounded-2xl px-24 py-20 flex flex-col items-center">
                <div className="w-20 h-24 bg-white rounded flex items-center justify-center mb-6">
                  <svg className="w-12 h-14 text-[#8696a0]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                </div>
                <p className="text-[#8696a0] text-sm mb-1">No preview available</p>
                <p className="text-[#8696a0] text-xs">
                  {(files[currentIndex].size / 1024).toFixed(0)} kB - {files[currentIndex].name?.split('.').pop()?.toUpperCase()}
                </p>
              </div>
            )}
          </div>
          <div className="absolute bottom-0 left-0 right-0 bg-[#f0f2f5] pb-4 pt-2">
            <div className="flex items-center gap-2 px-4 max-w-3xl mx-auto">
              <div className="flex-1 flex items-center bg-white rounded-lg px-4 py-2.5">
                <input
                  type="text"
                  value={caption}
                  onChange={(e) => setCaption(e.target.value)}
                  placeholder="Type a message"
                  className="flex-1 bg-transparent text-[#111b21] placeholder-[#667781] text-sm outline-none"
                />
                <button className="text-[#54656f]"><Smile size={20} /></button>
              </div>
              <button onClick={sendImages} className="bg-[#00a884] hover:bg-[#06cf9c] text-white p-2.5 rounded-full">
                <Send size={18} />
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes slideUpDrawer { from { transform: translateY(100%); } to { transform: translateY(0); } }
        @keyframes slideDownDrawer { from { transform: translateY(0); } to { transform: translateY(100%); } }
      `}</style>

      {/* Main Input Area */}
      {!showModal && (
        <div className="p-3 bg-[#f0f2f5] border-t border-gray-200 relative">

          {/* Normal text input */}
          {!isRecording && !draftAudio && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (!message.trim()) return;
                if (!phoneId || !recipientNumber) { alert("Please select a contact first."); return; }
                onSendMessage(message, null, "", "text");
                setMessage("");
              }}
            >
              <div className="flex items-center gap-2 relative">
                {/* Emoji button */}
                <button
                  type="button"
                  onClick={() => setShowEmoji((prev) => !prev)}
                  disabled={!isTextAllowed}
                  className="p-2.5 hover:bg-gray-200/70 rounded-full transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed flex-shrink-0"
                >
                  <Smile size={22} className="text-gray-600" />
                </button>

                {/* Emoji picker */}
                {showEmoji && (
                  <div className="absolute bottom-full mb-2 left-0 z-50 shadow-2xl rounded-xl overflow-hidden">
                    <EmojiPicker
                      onEmojiClick={(emojiData) => setMessage((prev) => prev + emojiData.emoji)}
                      disableSkinTonePicker
                      width={340}
                      height={400}
                    />
                  </div>
                )}

                {/* Text input container */}
                <div className="relative flex-1">
                  <textarea
                    rows={1}
                    disabled={!isTextAllowed}
                    value={message}
                    onChange={(e) => {
                      setMessage(e.target.value);
                      e.target.style.height = "44px";
                      const maxHeight = 120;
                      const newHeight = Math.min(e.target.scrollHeight, maxHeight);
                      e.target.style.height = newHeight + "px";
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        if (!message.trim() || !phoneId || !recipientNumber || !isTextAllowed) return;
                        onSendMessage(message, null, "", "text");
                        setMessage("");
                        e.target.style.height = "auto";
                      }
                    }}
                    placeholder={isTextAllowed ? "Type a message" : "24h window closed — send a template"}
                    style={{ height: "44px", lineHeight: "20px", paddingTop: "12px", paddingBottom: "12px" }}
                    className={`w-full resize-none border-none rounded-3xl pl-4 pr-28 py-[10px] outline-none focus:outline-none focus:ring-0 text-[15px] overflow-y-auto shadow-sm overscroll-contain
                      ${isTextAllowed ? "bg-white" : "bg-gray-100 cursor-not-allowed text-gray-500"}`}
                  />

                  {/* Attachment buttons inside input */}
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
                    <button
                      type="button"
                      onClick={() => fileRef.current?.click()}
                      disabled={!isMediaAllowed}
                      className="p-2 hover:bg-gray-100 rounded-full transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed"
                    >
                      <Paperclip size={20} className="text-gray-600" />
                    </button>
                    <button
                      type="button"
                      onClick={() => cameraRef.current?.click()}
                      disabled={!isMediaAllowed}
                      className="p-2 hover:bg-gray-100 rounded-full transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed"
                    >
                      <Camera size={20} className="text-gray-600" />
                    </button>
                  </div>

                  <input type="file" ref={fileRef} className="hidden" accept="image/*,video/*,audio/*,.pdf,.doc,.docx" multiple onChange={handleFilesChange} />
                  <input type="file" ref={cameraRef} className="hidden" accept="image/*" capture="environment" multiple onChange={handleFilesChange} />
                </div>

                {/* ── Template button — always visible, left of send/mic ── */}
                <button
                  type="button"
                  onClick={() => {
                    setShowEmoji(false);
                    setShowTemplates((prev) => !prev);
                  }}
                  title="Send a template"
                  className={`p-3 rounded-full transition-all duration-200 shadow-md flex-shrink-0
                    ${showTemplates
                      ? "bg-[#00a884] text-white shadow-lg scale-105"
                      : "bg-white hover:bg-gray-50 text-[#54656f] hover:text-[#111b21] hover:shadow-lg hover:scale-105 active:scale-95"
                    }`}
                >
                  <LayoutTemplate size={20} />
                </button>

                {/* Send button or Mic */}
                {message.trim() ? (
                  <button
                    type="submit"
                    disabled={!phoneId || !recipientNumber || !isTextAllowed}
                    className={`p-3 rounded-full transition-all duration-200 shadow-md flex-shrink-0 ${!phoneId || !recipientNumber || !isTextAllowed
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-gradient-to-br from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white hover:shadow-lg hover:scale-105 active:scale-95"
                      }`}
                  >
                    <Send size={20} />
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={startRecording}
                    disabled={!phoneId || !recipientNumber || !isMediaAllowed}
                    className={`p-3 rounded-full transition-all duration-200 shadow-md flex-shrink-0 ${!phoneId || !recipientNumber || !isMediaAllowed
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-gradient-to-br from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white hover:shadow-lg hover:scale-105 active:scale-95"
                      }`}
                  >
                    <Mic size={20} />
                  </button>
                )}
              </div>

              {/* Template picker — floats above the input row */}
              {showTemplates && (
                // <TemplateModal
                //   onClose={() => setShowTemplates(false)}
                //   onSelect={handleTemplateSelect}
                // />
                <TemplateModal
                  onClose={() => setShowTemplates(false)}
                  // templates={normalizeTemplates(templates.filter(t => t.status === "APPROVED"))}
                  templates={templates.filter(t => t.status === "APPROVED").map(t => t)}
                  onSelectTemplate={handleTemplateSelect}
                  selectedTemplate={selectedTemplate}
                  variables={templateVariables}
                  setVariables={setTemplateVariables}
                  onSend={handleSendTemplate}
                />
              )}
            </form>
          )}

          {/* Recording State */}
          {isRecording && !draftAudio && (
            <div className={`flex items-center bg-white gap-3 rounded-full px-4 py-2.5 shadow-sm ${isPaused && isPlayingPreview ? 'bg-[#d1f4dd]' : 'bg-white'}`}>
              <button type="button" onClick={deleteRecording} className="text-[#54656f] hover:text-[#111b21] transition-colors flex-shrink-0">
                <Trash2 size={20} />
              </button>
              {!isPaused ? (
                <div className="flex items-center gap-2 flex-shrink-0">
                  <div className="w-2 h-2 bg-red-500 rounded-full" style={{ animation: 'pulse 1.5s ease-in-out infinite' }}></div>
                  <span className="text-[15px] font-normal text-[#111b21] tabular-nums min-w-[35px]">{formatTime(recordingTime)}</span>
                </div>
              ) : (
                <button type="button" onClick={togglePreviewPlayback} className="text-[#54656f] hover:text-[#111b21] transition-colors flex-shrink-0">
                  {isPlayingPreview ? <Pause size={20} fill="currentColor" /> : <Play size={20} fill="currentColor" />}
                </button>
              )}
              <div className="flex-1 flex items-center justify-start h-6 overflow-hidden px-2">
                <div className="flex items-center gap-[2px] h-full">
                  {waveformData.length > 0 ? (
                    waveformData.slice(0, 60).map((height, i) => (
                      <div key={i} className="w-[2px] rounded-full bg-[#8696a0] transition-all duration-75" style={{ height: `${height}px` }} />
                    ))
                  ) : (
                    Array.from({ length: 3 }).map((_, i) => (
                      <div key={i} className="w-[2px] rounded-full bg-[#d1d7db]" style={{ height: '8px' }} />
                    ))
                  )}
                </div>
              </div>
              {isPaused && (
                <span className="text-[15px] font-normal text-[#111b21] tabular-nums flex-shrink-0 min-w-[35px]">{formatTime(recordingTime)}</span>
              )}
              <div className="flex items-center gap-3 flex-shrink-0">
                <button type="button" onClick={isPaused ? resumeRecording : pauseRecording} className="text-[#54656f] hover:text-[#111b21] transition-colors">
                  {isPaused ? <Mic size={22} /> : <Pause size={22} />}
                </button>
                <button
                  type="button"
                  onClick={() => { shouldSendAfterStopRef.current = true; stopRecording(); }}
                  className="bg-[#00a884] hover:bg-[#06cf9c] text-white p-2.5 rounded-full transition-all duration-200"
                >
                  <Send size={18} />
                </button>
              </div>
            </div>
          )}

          {/* Audio preview */}
          {draftAudio && (
            <div className="flex items-center gap-2 bg-white rounded-full px-4 py-2.5 shadow-lg border border-gray-100">
              <div className="flex-1 min-w-0">
                <audio controls src={draftAudio} className="w-full h-8 bg-white" />
              </div>
              <span className="text-xs font-medium text-gray-600 tabular-nums flex-shrink-0">{formatTime(recordingTime)}</span>
              <button
                onClick={sendAudioDirect}
                disabled={isSendingAudio}
                className="bg-green-500 hover:bg-green-600 disabled:bg-green-400 text-white p-2.5 rounded-full transition-all duration-200 shadow-md hover:shadow-lg disabled:shadow-none flex items-center justify-center min-w-[40px] hover:scale-110 active:scale-95 disabled:scale-100 flex-shrink-0"
              >
                {isSendingAudio ? (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  <Send size={16} />
                )}
              </button>
              <button
                onClick={deleteRecording}
                disabled={isSendingAudio}
                className="text-red-500 hover:bg-red-50 disabled:text-red-300 disabled:bg-transparent p-2 rounded-full transition-all duration-200 hover:scale-110 active:scale-95 disabled:scale-100 flex-shrink-0"
              >
                <Trash2 size={16} />
              </button>
            </div>
          )}
        </div>
      )}

      <style jsx>{`
        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
      `}</style>
    </>
  );
};

export default MessageInput;